/**
 * Asynchronously loads the component for AttributeGroup
 */

import { lazyLoad } from 'utils/loadable';

export const AttributeGroup = lazyLoad(
  () => import('./index'),
  module => module.AttributeGroup
);
